import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ProductSection } from './components/ProductSection';
import { BonusesSection } from './components/BonusesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { PurchasePopup } from './components/PurchasePopup';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const pixelId = '2069197916973057';
    const w = window as any;
    if (w.fbq) return;
    const n: any = w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="w-full min-h-screen bg-[#0a0f1a]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <ProductSection data-id="element-3" />
      <BonusesSection data-id="element-4" />
      <PricingSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <Footer data-id="element-7" />
      <PurchasePopup data-id="element-8" />
    </div>;
}